import server from "@config/server";

class AuthService {
  static async login(user) {
    const res = await server.post(`/login`, user);
    const json = res.data;
    if (json.success) {
      localStorage.setItem("token", json.data.user.token);
      return true;
    } else {
      return false;
    }
  }
}

export default AuthService;
